import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-cinema-surface">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">动态速递</h2>
          <p className="text-sm text-cinema-muted">最新上线 · 片库更新 · 热门活动</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-cinema-border"></div>
          <div className="space-y-0">
            {updateItems.map((item, i) => (
              <a
                key={i}
                href="#ranking"
                className="group relative flex gap-4 md:gap-6 pb-8 last:pb-0 cursor-pointer"
              >
                <div className="relative z-10 flex-shrink-0 w-8 md:w-12 flex justify-center">
                  <div className="w-3 h-3 rounded-full bg-cinema-gold mt-1.5 group-hover:scale-125 transition-transform ring-4 ring-cinema-surface"></div>
                </div>
                <div className="flex-1 min-w-0 bg-cinema-card hover:bg-cinema-card-hover border border-cinema-border hover:border-cinema-gold/20 rounded-lg p-4 md:p-5 transition-all duration-300">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-cinema-muted font-mono">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${item.tagClass} whitespace-nowrap`}>{item.tag}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-white group-hover:text-cinema-gold transition-colors mb-1">{item.title}</h3>
                  <p className="text-xs text-cinema-muted leading-relaxed">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}